import { css } from '@emotion/react'
import clsx from 'clsx'
import React, { useState } from 'react'
import { Button, ButtonGroup } from './'

function Tab({
    tabs,
    children,
    justify,
    onTabChange,
    style,
    hideHeader = false
}) {
    const [activeTab, setActiveTab] = useState(0)
    const activeColor = 'primary'
    const firstColor = 'lighter'
    return (
        <div
            css={css`${style}`}
            className={`tabs flex flex-wrap justify-${justify}`}
        >
            {!hideHeader && (
                <ButtonGroup color="white">
                    {tabs.map((item, idx) => (
                        <div key={idx}>
                            <Button
                                onClick={() => {
                                    setActiveTab(idx)
                                    onTabChange?.(tabs[idx], idx)
                                }}
                                backgroundColor={
                                    idx === activeTab ? activeColor : firstColor
                                }
                                className={clsx(
                                    'p-4',
                                    idx === activeTab && 'active-button'
                                )}
                            >
                                {item.label}
                            </Button>
                        </div>
                    ))}
                </ButtonGroup>
            )}
            <div className="w-full tab-content basis-full pt-6">
                {children[activeTab]}
            </div>
        </div>
    )
}

export default Tab
